<template>
  <v-app id="webwalker">
    <main-nav
      v-if="!isAuthView"
      @logout="logout()"
    />

    <v-main
      :class="{ background: !isAuthView, 'bg-blue-darken-3': isAuthView }"
    >
      <transition-container>
        <router-view />
      </transition-container>
    </v-main>
  </v-app>
</template>

<script>
import AuthApi from '@/api/AuthApi';
import MainNav from '@/components/layout/MainNav.vue';
import TransitionContainer from '@/components/layout/TransitionContainer.vue';
import { setDarkMode } from '@/helpers/vuetifyTheme';

export default {
  name: 'WebwalkerAffiliate',

  components: {
    MainNav,
    TransitionContainer,
  },

  data: () => ({
    interval: null,
    /** Seconds between authenticated GET /user refreshes. */
    refreshInterval: 60,
  }),

  computed: {
    isDarkMode() {
      return this.$store.state.isDarkMode;
    },

    isAuthenticated() {
      return this.$store.getters.authenticated;
    },

    isAuthView() {
      if (this.$route && this.$route.meta) {
        return this.$route.meta.public;
      }
      return false;
    },
  },

  watch: {
    isDarkMode(val) {
      // Sync Vuex → Vuetify 3 theme (same path as Vue 2 $darkMode assignment on master)
      setDarkMode(val);
      this.rootScrollColor();
    },

    isAuthenticated(val) {
      if (!val && this.$route && !this.$route.meta.public) {
        this.$router.replace('/login');
      }
    },

    $route() {
      this.$store.dispatch('clearErrors');
    },
  },

  mounted() {
    this.loadData();
    this.interval = setInterval(() => {
      this.loadData();
    }, this.refreshInterval * 1000);
    this.rootScrollColor();
    setDarkMode(this.$store.state.isDarkMode);
  },

  beforeUnmount() {
    if (this.interval) clearInterval(this.interval);
  },

  methods: {
    loadData() {
      if (this.$store.getters.authenticated) {
        this.$store.dispatch('loadUser');
      }
      setDarkMode(this.$store.state.isDarkMode);
    },

    logout() {
      AuthApi.logout()
        .then(() => {
          localStorage.clear();
          window.location.reload();
        })
        .catch((error) => {
          if (error.response && error.response.data && error.response.data.errors) {
            this.$store.dispatch('pushErrors', error.response.data.errors);
          }
          localStorage.clear();
        });
    },

    rootScrollColor() {
      const root = document.querySelector(':root');
      if (this.isDarkMode) {
        root.classList.add('scroll-dark');
      } else {
        root.classList.remove('scroll-dark');
      }
    },
  },
};
</script>
